import React from "react";
import cbModal from "../Modal/Modal";
import { EntryPickerModal } from "./EntryPickerModal/EntryPickerModal";
import { OpenEntryPickerModalArgs } from "./types";

export function openEntryPickerModal(args: OpenEntryPickerModalArgs) {

  cbModal({
    component: (modalProps: any) =>
      <EntryPickerModal
        {...args}
        closeModal={modalProps?.closeModal}
      />,
    modalProps: {
      size: "max",
      onClose: args.onClose,
    },
  })
}